import { render } from "./RolesList.vue?vue&type=template&id=58fc7b23&scoped=true"
import script from "./RolesList.vue?vue&type=script&lang=js"
export * from "./RolesList.vue?vue&type=script&lang=js"

import "./RolesList.vue?vue&type=style&index=0&id=58fc7b23&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58fc7b23"]])

export default __exports__